import apiClient from "../api";

export const createModel = async (modelData) => {
    try {
        const token = await localStorage.getItem('token');

        const response = await apiClient.post("gestock/models/create", modelData,
            {
                headers: { Authorization: `Bearer ${token}` },
            }
        );
        return response.data;
    } catch (error) {
        console.log({ error });
        throw error.response?.data || error;
    }
};
